import { getHtmlFromString } from '@/util/stringToHtml';
import './quill-snow.css';
import { useFonts } from '@/hooks/useFont';
import { ICanvasElement } from '@/interface/canvas';
import { getScreenElementStyle } from '@/util/canvas';

export const TextPreview = ({ element }: TextPreviewProps) => {
  const style = getScreenElementStyle(element);
  const { isLoaded } = useFonts({ textContent: element?.text || '' });
  if (!isLoaded) return <></>;
  return (
    <div
      className="text-center txt-prev flex justify-center items-center ql-snow"
      id={element.id}
      style={style}
    >
      <div className="quill">
        <div className="ql-container">
          <div
            dangerouslySetInnerHTML={getHtmlFromString(element?.text || '')}
            className="ql-editor"
          />
        </div>
      </div>
    </div>
  );
};
type TextPreviewProps = {
  element: ICanvasElement;
};
export default TextPreview;
